import { render, staticRenderFns } from "./BillingInfo.vue?vue&type=template&id=b22897fc&scoped=true"
import script from "./BillingInfo.vue?vue&type=script&lang=js"
export * from "./BillingInfo.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/contract_form/billing_info.css?vue&type=style&index=0&id=b22897fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22897fc",
  null
  
)

export default component.exports